import {
  ADMIN_ROLE,
  GUEST_ROLE,
  INSTRUCTOR_ROLE,
  STUDENT_ROLE,
} from "@constants";

const sidebarLinkList = {
  default: [
    {
      roles: [GUEST_ROLE, STUDENT_ROLE, INSTRUCTOR_ROLE],
      title: "Home",
      path: "/",
      icon: <i className="bi bi-house"></i>,
    },
    {
      roles: [GUEST_ROLE, STUDENT_ROLE, INSTRUCTOR_ROLE],
      title: "Explore",
      path: "/explore",
      icon: <i className="bi-search"></i>,
    },
    {
      roles: [GUEST_ROLE, STUDENT_ROLE, INSTRUCTOR_ROLE],
      title: "Categories",
      path: "/categories",
      icon: <i className="bi bi-layers"></i>,
    },
    {
      roles: [STUDENT_ROLE, INSTRUCTOR_ROLE],
      title: "Saved Courses",
      path: "/saved-courses",
      icon: <i className="bi bi-heart"></i>,
    },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "Cursus Studio",
      path: "/instructor-dashboard",
      icon: <i className="bi bi-grid"></i>,
    },
    {
      roles: [STUDENT_ROLE],
      title: "Cursus Studio",
      path: "/student-dashboard",
      icon: <i className="bi bi-grid"></i>,
    },
  ],
  dashBoard: [
    {
      title: "Home",
      path: "/",
      icon: <i className="bi bi-house"></i>,
    },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "Dashboard",
      path: "/instructor-dashboard",
      icon: <i className="bi bi-grid"></i>,
    },
    // {
    //   roles: [STUDENT_ROLE],
    //   title: "Dashboard",
    //   path: "/student-dashboard",
    //   icon: <i className="bi bi-grid"></i>,
    // },
    {
      roles: [INSTRUCTOR_ROLE, STUDENT_ROLE],
      title: "My Learning",
      path: "/my-learning",
      icon: <i className="bi bi-book"></i>,
    },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "My Courses",
      path: "/instructor-courses",
      icon: <i className="bi bi-journals"></i>,
    },
    // {
    //   roles: [INSTRUCTOR_ROLE],
    //   title: "Analytics",
    //   path: "/instructor-analytics",
    //   icon: <i className="bi bi-graph-up-arrow"></i>,
    // },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "Create Course",
      path: "/create-new-course",
      icon: <i className="bi bi-plus-circle"></i>,
    },
    {
      roles: [INSTRUCTOR_ROLE, STUDENT_ROLE],
      title: "Credits",
      path: "/credits",
      icon: <i className="bi bi-credit-card" />,
    },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "Earning",
      path: "/instructor-earning",
      icon: <i className="bi bi-currency-dollar"></i>,
    },
    // {
    //   roles: [INSTRUCTOR_ROLE],
    //   title: "Payout",
    //   path: "/instructor-payout",
    //   icon: <i className="bi bi-wallet2"></i>,
    // },
    // {
    //   roles: [INSTRUCTOR_ROLE],
    //   title: "Statements",
    //   path: "/statements",
    //   icon: <i className="bi bi-file-earmark-text" />,
    // },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "My Feedback",
      path: "/instructor-all-reviews",
      icon: <i className="bi bi-card-text"></i>,
    },
    {
      roles: [INSTRUCTOR_ROLE],
      title: "Reviews",
      path: "/my-reviews-ins",
      icon: <i className="bi bi-star"></i>,
    },
    {
      roles: [STUDENT_ROLE],
      title: "Purchased Courses",
      path: "/my-purchased-courses",
      icon: <i className="bi bi-journals"></i>,
    },
    {
      roles: [STUDENT_ROLE],
      title: "Reviews",
      path: "/my-reviews",
      icon: <i className="bi bi-star"></i>,
    },
  ],
  admin: [
    // {
    //   roles: [ADMIN_ROLE],
    //   title: "Dash Board",
    //   path: "/admin",
    //   icon: <i className="bi bi-grid"></i>,
    // },
    {
      roles: [ADMIN_ROLE],
      title: "Manage Courses",
      path: "/admin-manage-courses",
      icon: <i className="bi bi-collection-play"></i>,
    },
    // {
    //   roles: [ADMIN_ROLE],
    //   title: "Manage Categories",
    //   path: "/admin-manage-categories",
    //   icon: <i className="bi bi-layers"></i>,
    // },
    {
      roles: [ADMIN_ROLE],
      title: "Manage Students",
      path: "/admin-manage-students",
      icon: <i className="bi bi-mortarboard"></i>,
    },
    {
      roles: [ADMIN_ROLE],
      title: "Manage Instructors",
      path: "/admin-manage-instructors",
      icon: <i className="bi bi-people"></i>,
    },
    // {
    //   roles: [ADMIN_ROLE],
    //   title: "Manage Admins",
    //   path: "/admin-manage-admins",
    //   icon: <i className="bi bi-person-badge"></i>,
    // },
  ],
};

const settingMenuList = {
  default: [
    {
      roles: [STUDENT_ROLE, INSTRUCTOR_ROLE],
      icon: <i className="bi bi-gear"></i>,
      path: "/setting",
      title: "Setting",
    },
    // {
    //   icon: <i className="bi bi-question-circle"></i>,
    //   path: "/help",
    //   title: "Help",
    // },
    // {
    //   icon: <i className="bi-chat-right-quote"></i>,
    //   path: "/send-feedback",
    //   title: "Send Feedback",
    // },
  ],
  dashBoard: [
    {
      roles: [STUDENT_ROLE, INSTRUCTOR_ROLE],
      icon: <i className="bi bi-gear"></i>,
      path: "/setting",
      title: "Setting",
    },
    // {
    //   icon: <i className="bi bi-question-circle"></i>,
    //   path: "/help",
    //   title: "Help",
    // },
    // {
    //   icon: <i className="bi-chat-right-quote"></i>,
    //   path: "/send-feedback",
    //   title: "Send Feedback",
    // },
  ],
  admin: [
    {
      roles: [ADMIN_ROLE],
      icon: <i className="bi bi-gear"></i>,
      path: "/admin-setting",
      title: "Setting",
    },
  ],
};

const footerLinkList = [
  { title: "About", path: "/about" },
  { title: "Press", path: "/press" },
  { title: "Contact Us", path: "/contact-us" },
  { title: "Advertise", path: "/advertise" },
  { title: "Developers", path: "/developers" },
  { title: "Copyright", path: "/copyright" },
  { title: "Privacy Policy", path: "/privacy-policy" },
  { title: "Terms", path: "/terms" },
];

const socialMediaList = [
  { title: "About", icon: <i className="bi bi-facebook"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-twitter"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-google"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-linkedin"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-instagram"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-youtube"></i>, path: "/" },
  { title: "About", icon: <i className="bi bi-pinterest"></i>, path: "/" },
];

export { sidebarLinkList, footerLinkList, settingMenuList, socialMediaList };
